import React, { Component } from "react"
import botLaptop from "../images/bot-laptop.svg";
import bot from "../images/bot.svg";
import whiteBot from "../images/white-bot.svg";
import chatWithWill from "../images/chat-with-will.svg";
import call311 from "../images/call-311.svg";
import mobileApp from "../images/mobile-app.svg";
import onlinePortal from "../images/online-portal.svg";
import messagesSvg from "../images/messages-svg.svg";
import playVideo from "../images/play-video.svg";
import appleStore from "../images/apple-store.svg";


class LandingDarkBackgr extends Component {

  render() {
    const layout = this.props.content
    return (
    <div className="container">
      <div className="uk-child-width-1-2@m" data-uk-grid>
        <div className="left-column">
          {layout.relationships?.field_media_image?.relationships?.field_media_image ? (
            <img className="uk-object-contain" src={layout.relationships?.field_media_image?.relationships?.field_media_image.uri?.url} alt={layout.relationships?.field_media_image?.relationships?.field_media_image.filename} />
          ) : (
            null
          )}
        </div>
        <div className="right-column">
          <h2 className="section-311-blue-section-title">{layout.field_title}</h2>
          <div className="items-wrapper">
            {layout.relationships.field_icon_with_description && layout.relationships.field_icon_with_description.map( (item,key) => (
              <div className="section-311-blue-section-item" key={`landing-dark-bgr-${key}`}>
                <div className="section-311-blue-wrp">
                  <div className="section-311-blue-icon-wrp">
                    <img src={item.relationships.field_icon?.uri?.url} alt="icon" />
                  </div>
                  <div className="icons-text-wrp h3"  dangerouslySetInnerHTML={{ __html: item.field_description_wysiwyg?.processed }} />
                </div>
              </div>
            ))}
          </div>

          {/*<div className="section-311-blue-section-item">
            <div className="section-311-blue-wrp">
              <div className="section-311-blue-icon-wrp">
              </div>
              <div className="icons-text-wrp h3">
                <a href="#">
                  <img src={appleStore} alt="" />
                </a>
                <a href="#">
                  <img src={appleStore} alt="" />
                </a>
              </div>
            </div>
          </div>*/}

        </div>
      </div>
    </div>
    )
  }
}

export default LandingDarkBackgr
